module.exports = __webpack_public_path__ + "static/media/instagram.a43362f8.png";